import { resolveURL } from "../utils/url.js";
async function fetchProfiles(baseURL) {
  const response = await fetch(resolveURL("/api/v3/profiles", baseURL));
  const data = await response.json().catch();
  if (!response.ok || !(data == null ? void 0 : data.objects)) {
    return [];
  }
  return data.objects;
}
export {
  fetchProfiles
};
